import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1jsnz1e7d6: FaireBrandEntity = {
  token: "b_1jsnz1e7d6",
  type: "brand",
  name: "Blu Pepper",
  avatarUrl:
    "https://cdn.faire.com/fastly/a7d30d70555c15c1f15b152d3b941b121e727c691b21ae40592ffb3408c329ed.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/375a1108a2a6e4810ac294a617b5fb610a5c75b69b3fac6088b9530ed228cb15.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a7d30d70555c15c1f15b152d3b941b121e727c691b21ae40592ffb3408c329ed.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/375a1108a2a6e4810ac294a617b5fb610a5c75b69b3fac6088b9530ed228cb15.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.7,
  reviewCount: 1692,
  isInsider: true,
  description:
    "At Blu Pepper we offer a wide selection of wholesale apparel at competitive prices. Our bohemian curated pieces include dresses, rompers, outerwear, tops, sweaters, denim, and bottoms. As we are located in the heart of Los Angeles Fashion District, we are always staying on trend as we want to to provide the highest quality as well as the most fashionable collections to our customers. From Blu Pepper's inception in 2010, we have been dedicated to styling the young bohemian-inspired girl and our wholesale bohemian brand is always on trend with youthful, flirty, and vintage-inspired pieces. At Blu Pepper, not only will you access the best quality and prices in wholesale clothing but in service as well. We are committed to providing you with the best deals and customer care the wholesale retail industry has to offer. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:57.059Z",
    importedBy: "entity-db-cli",
  },
};
